var EntityColors = {
  "Default": "#333333",
  "Undefined": "#969696",
  "Epic": "#3AB5A2",
  "Feature": "#60A554",
  "UserStory": "#068CBA",
  "Bug": "#AE304A",
  "Task": "#30438C",
  "Request": "#CDAF3F",
  "TestCase": "#E6961E",
  "TestStep": "#ADB300",
  "TestCaseRun": "#ECB056",
  "TestPlan": "#CDAF3F",
  "TestRun": "#A16915",
  "TestPlanRun": "#8A5A12",
  "Impediment": "#AE304A",
  "Release": "#333",
  "Iteration": "#556FCF",
  "TeamIteration": "#556FCF",
  "Build": "#319A8A",
  "Allocation": "#AECB6A",
  "ProjectMember": "#AECB6A",
  "UserProjectAllocation": "#AECB6A",
  "TeamProjectAllocation": "#AECB6A",
  "Comment": "#8596A7",
  "PortfolioEpic": "#340068",
  "Project": "#1A1A1D",
  "Milestone": "#8596A7"
};
var EntityPalettes = {
  "Default": {
    "100": "#D6D6D6",
    "500": "#333333"
  },
  "Undefined": {
    "100": "#EAEAEA",
    "500": "#969696"
  },
  "Epic": {
    "100": "#D8F0EC",
    "500": "#3AB5A2"
  },
  "Feature": {
    "100": "#DFEDDD",
    "500": "#60A554"
  },
  "UserStory": {
    "100": "#CDE8F1",
    "500": "#068CBA"
  },
  "Bug": {
    "100": "#EFD6DB",
    "500": "#AE304A"
  },
  "Task": {
    "100": "#EEF0F6",
    "500": "#30438C"
  },
  "Request": {
    "100": "#F5EFD9",
    "500": "#CDAF3F"
  },
  "TestCase": {
    "100": "#FAEAD2",
    "500": "#E6961E"
  },
  "TestStep": {
    "100": "#F7F7E6",
    "500": "#ADB300"
  },
  "TestCaseRun": {
    "100": "#FBEFDD",
    "500": "#ECB056"
  },
  "TestPlan": {
    "100": "#F5EFD9",
    "500": "#CDAF3F"
  },
  "TestRun": {
    "100": "#ECE1D0",
    "500": "#A16915"
  },
  "TestPlanRun": {
    "100": "#E8DED0",
    "500": "#8A5A12"
  },
  "Impediment": {
    "100": "#EFD6DB",
    "500": "#AE304A"
  },
  "Release": {
    "100": "#EBEBEB",
    "500": "#333333"
  },
  "Iteration": {
    "100": "#DDE2F5",
    "500": "#556FCF"
  },
  "TeamIteration": {
    "100": "#DDE2F5",
    "500": "#556FCF"
  },
  "Build": {
    "100": "#D6EBE8",
    "500": "#319A8A"
  },
  "Allocation": {
    "100": "#F7FAF0",
    "500": "#AECB6A"
  },
  "ProjectMember": {
    "100": "#F7FAF0",
    "500": "#AECB6A"
  },
  "UserProjectAllocation": {
    "100": "#F7FAF0",
    "500": "#AECB6A"
  },
  "TeamProjectAllocation": {
    "100": "#F7FAF0",
    "500": "#AECB6A"
  },
  "Comment": {
    "100": "#EDEFF2",
    "500": "#8596A7"
  },
  "PortfolioEpic": {
    "100": "#EBE6F0",
    "500": "#340068"
  },
  "Project": {
    "100": "#D1D1D2",
    "500": "#1A1A1D"
  },
  "Milestone": {
    "100": "#E7EAED",
    "500": "#8596A7"
  }
};
var GeneralColors = {
  "Primary": "#60A554",
  "Second": "#404249",
  "Third": "#007EFF",
  "Danger": "#AE304A",
  "Active": "#F1CE4A",
  "Warning": "#E6961E",
  "MrWhite": "#FFFFFF",
  "DrBlack": "#000000"
};
var GeneralPalettes = {
  "Primary": {
    "100": "#E7F2E5",
    "200": "#B7D7B2",
    "300": "#A0C998",
    "400": "#88BC7F",
    "500": "#60A554",
    "600": "#5B9D50",
    "700": "#56954C",
    "800": "#355B2E",
    "900": "#264222"
  },
  "Second": {
    "100": "#F5F6F6",
    "200": "#ECECED",
    "300": "#E2E3E4",
    "400": "#A0A1A4",
    "500": "#404249",
    "600": "#36383E",
    "700": "#2D2E33",
    "800": "#232428",
    "900": "#1A1A1D"
  },
  "Third": {
    "100": "#D9ECFF",
    "200": "#8CC5FF",
    "300": "#66B2FF",
    "400": "#409EFF",
    "500": "#007EFF",
    "600": "#006BD9",
    "700": "#0058B3",
    "800": "#00458C",
    "900": "#003266"
  },
  "Danger": {
    "100": "#F3E0E4",
    "200": "#DBA2AE",
    "300": "#CE8392",
    "400": "#C26477",
    "500": "#AE304A",
    "600": "#A52E46",
    "700": "#9D2B43",
    "800": "#601A29",
    "900": "#46131E"
  },
  "Active": {
    "100": "#FCF5DB",
    "200": "#F9E9AE",
    "300": "#F7E292",
    "400": "#F5DA77",
    "500": "#F1CE4A",
    "600": "#CDAF3F",
    "700": "#A99034",
    "800": "#857129",
    "900": "#60521E"
  },
  "Warning": {
    "100": "#FAEAD2",
    "200": "#F4D09A",
    "300": "#F0C078",
    "400": "#ECB056",
    "500": "#E6961E",
    "600": "#C4801A",
    "700": "#A16915",
    "800": "#7F5311",
    "900": "#5C3C0C"
  }
};

export { EntityColors, EntityPalettes, GeneralColors, GeneralPalettes };
